import { EditTemplate } from '../../../../../../components/default-card-template/components/edit-template';
import { withAdditionalProps } from '../../../../../../hoc/with-additional-props';

import { renderControls } from './components/render-controls';

const EditTemplateWithControls = withAdditionalProps(EditTemplate, { renderControls });

export { EditTemplateWithControls as EditTemplate };
